import { render, staticRenderFns } from "./ForecastsTableInfoRow.vue?vue&type=template&id=381faba0&"
import script from "./ForecastsTableInfoRow.vue?vue&type=script&lang=js&"
export * from "./ForecastsTableInfoRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports